module.exports = __webpack_public_path__ + "img/ES6837.e5bf0c8d.svg";